import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { CombinedFunnelComponentSteppedInputProps } from '../CombinedFunnelMobile.types'
import { FC } from 'react'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { useCombinedFunnelMobileAuthState } from './Auth.hooks'
import AuthForm from '../../../upgrade/UpgradeAuthForm'

export const CombinedFunnelMobileAuth: FC<CombinedFunnelComponentSteppedInputProps> = ({
  variant
}) => {
  const {
    isSignUp,
    setIsSignUp,
    handleGenerateCode,
    handSubmitBtnEvents,
    handleFacebookBtnEvents,
    onClickGoogleBtn
  } = useCombinedFunnelMobileAuthState(variant)

  return (
    <Box flexDirection={'column'} m="16px 24px 6px" alignItems={'center'}>
      <Text
        fontSize={'18px'}
        fontWeight={600}
        lineHeight="22px"
        textAlign={'center'}
        maxWidth="297px"
      >
        {isSignUp
          ? 'Step 2 of 2: Sign up for free to claim your Flowcode'
          : 'Step 2 of 2: Sign in to your Flowcode account'}
      </Text>
      <Spacer mb="20px" />
      <AuthForm
        isSignUp={isSignUp}
        onAuthFormToggle={() => setIsSignUp(!isSignUp)}
        isMobile
        onClickSubmitBtn={handSubmitBtnEvents}
        onClickFacebookBtn={handleFacebookBtnEvents}
        onClickGoogleBtn={onClickGoogleBtn}
        onSuccess={handleGenerateCode}
      />
    </Box>
  )
}
